module.exports = __webpack_public_path__ + "img/downLoadW.09f8f9f8.svg";